module.exports = __webpack_public_path__ + "assets/images/5uzSpwRv.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wopi-error.png
// module id = 1136
// module chunks = 0